// Curated, canonical tags surfaced as one-tap chips on the upload flow, so tags
// stay predictable instead of sprawling into typos and synonyms from free text.
//
// Kept lowercase to match the app's tag convention (see Step2Review /
// Step3Details tag normalization). Ordered by theme for scannability. This is
// the single place to edit the common-tag vocabulary — add tags here as they
// recur in real uploads. Free-text custom tags are still allowed; watch what
// users type and graduate the good ones into this list.
export const COMMON_TAGS = [
  // Pet
  'dog',
  'cat',
  'exotic',
  // Life stage
  'puppy',
  'kitten',
  'senior',
  // Visit type
  'wellness',
  'sick visit',
  'emergency',
  // Care
  'exam',
  'vaccines',
  'dental',
  'bloodwork',
  'imaging',
  'surgery',
  'spay/neuter',
  'medications',
  'flea/tick/heartworm',
  'microchip',
  // Cost context
  'discount',
  'estimate'
];
